<template>
  <Head title="Direct Mail - Edit Appeal" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <appeal-edit 
            :client="client" 
            :appeal="appeal"
            :layouts="layouts"
            :segments="segments"
            :data_blend="data_blend"
          ></appeal-edit>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  appeal: Object,
  layouts: Array,
  segments: Array,
  data_blend: Object
});
</script>

